import React from 'react'

const Image = (props) => {
    const classNames = ["image"]
    if (props.settings.class) {
        classNames.push(props.settings.class)
    }

    return (
        <div className={classNames.join(' ')}>
            <img src={ process.env.CMS_HOST + "/" + props.settings.image.path} alt="" width={props.settings.width} height={props.settings.height} />
        </div>  
    )
} 

export default Image


// WEBPACK FOOTER //
// ./src/components/Image.js